<script setup lang="ts"></script>

<template>
  <div class="col-md-6 offset-md-3">
    <h3>You've reset your password.</h3>
    <p>
      We've emailed you instructions for setting your password. If an account
      exists with the email you entered, you should receive the instructions
      shortly.
    </p>
    <p>
      If you don't receive an email, please make sure you've entered the address
      you registered with, and check your spam folder.
    </p>
  </div>
</template>

<style lang="scss" scoped></style>
